import { FC, SVGAttributes } from 'react';

type QuestionFruitSvgProps = SVGAttributes<SVGElement>;

export const QuestionFruitSvg: FC<QuestionFruitSvgProps> = ({ ...props }) => {
    return (
        <svg
            width="32"
            height="49"
            viewBox="0 0 32 49"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <circle
                cx="16.1667"
                cy="33.6668"
                r="14.6667"
                stroke="#10B5A8"
                strokeWidth="1.25714"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="2.51 5.03"
            />
            <path
                d="M8.08654 8.26185L8.61778 5.95985C10.5667 6.14022 11.5232 6.0167 11.6707 5.37726C11.8183 4.73782 11.0367 4.36289 10.2126 4.1727C8.93368 3.87756 7.73896 4.12568 6.60873 4.80775L5.33422 2.61287C6.85031 1.75044 8.57517 1.28043 10.8772 1.81167C13.3071 2.37243 15.7435 3.87759 15.2352 6.08012C14.8417 7.7853 13.0644 8.28811 10.9143 7.94159L10.7012 8.86523L8.08654 8.26185ZM8.50298 12.2942C7.3804 12.0351 6.77703 11.1475 6.99018 10.2239C7.20006 9.31447 8.13463 8.76685 9.25721 9.02591C10.3656 9.28169 10.9657 10.1835 10.7558 11.0929C10.5426 12.0165 9.61135 12.55 8.50298 12.2942Z"
                fill="#F3A900"
            />
        </svg>
    );
};
